import {CodebookModel} from '../models/codebook.model';

export class CategoryTypeCodebook {
    static allTypes:CodebookModel[] = [
        {
            id:1,
            name:'CategoryType-AAB'
        } , {
            id:2,
            name:'CategoryType-ABB'
        } , {
            id:3,
            name:'CategoryType-ACB'
        } , {
            id:4,
            name:'CategoryType-BAB'
        } , {
            id:5,
            name:'CategoryType-BCI'
        } , {
            id:6,
            name:'CategoryType-CAB'
        } , {
            id:7,
            name:'CategoryType-CED'
        } , {
            id:8,
            name:'CategoryType-EAI'
        } , {
            id:9,
            name:'CategoryType-EAJ'
        } , {
            id:10,
            name:'CategoryType-FAI'
        } , {
            id:11,
            name:'CategoryType-GII'
        } ,
    ];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/codebook/category-type-codebook.ts